import React from 'react';

import './PlayerRank.css';

function PlayerRank({ rank, title }) {
  let rankType;
  let rankString;

  switch (rank) {
    case 1:
      rankType = 'first';
      rankString = 'st';
      break;
    case 2:
      rankType = 'sec';
      rankString = 'nd';
      break;
    case 3:
      rankType = 'third';
      rankString = 'rd';
      break;
    case 4:
      rankString = 'th';
      break;
    default:
      rankString = 'th';
  }

  return (
    <div className="player-card-rank flex flex-col items-center">
      <p
        className={`rank flex items-center justify-center rounded-full text-sm font-semibold ${rank > 3 ? 'text-text400' : 'text-back200'} ${rankType} m-0 p-0`}
      >
        <span className="text-text300">
          {rank}
          {rankString}
        </span>
      </p>
      <span className="text-text600 m-0 p-0 pt-[10px] text-center text-xs">
        {title}
      </span>
    </div>
  );
}

export default PlayerRank;
